import { PersonTypeEnum } from './person';

/** Ростер fotoclass-app несёт роль строкой, редактор — enum; значения совпадают. */
export interface MasterDonorCandidate {
  readonly id: string;
  readonly type: PersonTypeEnum | `${PersonTypeEnum}`;
}

/** Донор эталона — только ученик: мастер собирается на его материале и судит рамки владельца его кадрами. */
export function isEligibleMasterDonor(person: Pick<MasterDonorCandidate, 'type'>): boolean {
  return person.type === PersonTypeEnum.STUDENT;
}

/** `null` — донора нет в ростере или он не ученик; оба случая читаются как «донора нет». */
export function eligibleMasterDonorId(
  donorId: string | null | undefined,
  roster: readonly MasterDonorCandidate[],
): string | null {
  if (!donorId) return null;
  const donor = roster.find(person => person.id === donorId);
  return donor && isEligibleMasterDonor(donor) ? donorId : null;
}
